
import React from "react";
import { AccountProvider } from "@/contexts/AccountContext";
import { ErrorBoundary } from "../components/recovery/ErrorBoundary";
import { ResilientDashboardLoader } from "../components/dashboard/ResilientDashboardLoader";

const Dashboard: React.FC = () => {
  React.useEffect(() => {
    console.log('[Dashboard] Dashboard page mounted - iOS compatible version');
    
    // Simple visibility fix for iOS without conflicting styles
    const root = document.getElementById('root');
    if (root) {
      root.style.display = 'block';
      root.style.visibility = 'visible';
      root.style.opacity = '1';
    }

    // Add body classes for styling hooks
    document.body.classList.add('has-bottom-nav', 'has-fab');
  }, []);

  return (
    <ErrorBoundary>
      <AccountProvider>
        <div 
          className="min-h-screen bg-white"
          data-testid="dashboard-content"
          style={{
            paddingTop: 'max(env(safe-area-inset-top, 20px), 44px)',
            minHeight: '100vh',
            paddingBottom: 'calc(env(safe-area-inset-bottom, 16px) + 88px)'
          }}
        >
          <ResilientDashboardLoader />
        </div>
      </AccountProvider>
    </ErrorBoundary>
  );
};

export default Dashboard;
